import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";

function MenuDialogs({
  openMenuNameDialog,
  menuName,
  confirmDeleteDialog,
  handleCloseMenuNameDialog,
  setConfirmDeleteDialog,
  deleteMenuName,
  confirmDelete,
  handleClose,
  handleInputChange,
  handleSaveMenuName,
  makeMenuDialog,
  handleMakeClose,
  handleChange,
  handleSave,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (openMenuNameDialog || makeMenuDialog) {
      inputRef.current?.focus();
    }
  }, [openMenuNameDialog, makeMenuDialog]);
  // this is make menu fist content Mak Your Menu heading
  return (
    <Dialog
      open={openMenuNameDialog || makeMenuDialog}
      onClose={handleCloseMenuNameDialog}
      PaperProps={{
        sx: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        },
      }}
    >
      <DialogTitle>Add Menu Name</DialogTitle>
      <DialogContent>
        <TextField
          // autoFocus
          inputRef={inputRef}
          margin="dense"
          id="menuName"
          label="Menu Name"
          type="text"
          fullWidth
          value={menuName}
          onChange={handleInputChange}
          helperText="Please enter a menu name to add items."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseMenuNameDialog}>Cancel</Button>
        <Button onClick={handleSaveMenuName}>Add</Button>
      </DialogActions>

    </Dialog>
  );
}

MenuDialogs.propTypes = {
  openMenuNameDialog: PropTypes.bool.isRequired,
  menuName: PropTypes.string.isRequired,
  confirmDeleteDialog: PropTypes.bool.isRequired,
  setConfirmDeleteDialog: PropTypes.func.isRequired,
  deleteMenuName: PropTypes.string.isRequired,
  confirmDelete: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSaveMenuName: PropTypes.func.isRequired,
};

export default MenuDialogs;
